var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pa-4 white radius-15"},[_c('personal-infos',{attrs:{"info":_vm.profileNew,"completeProfile":true},on:{"nextHandler":function($event){return _vm.$emit('nextHandler', 2)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }